export default "__VITE_ASSET__Df59$LCm__"